import React, { useEffect } from "react"
import { AppCardTitle, AppCrudTable, AppResultsSkeleton } from "@components"
import { useAdminListTable, useManageEnabledUsers } from "Pages/Admin/Users/@hooks"
import { actionsColumn, companyColumn, createdColumn, disabledColumn, emailColumn, nameColumn } from "Pages/Admin/Users/Table/@columns"
import { tableData } from "Pages/Admin/Users/@signals"
import enabledColumn from "Pages/Admin/Users/Table/@columns/enabled"
import MultipleUserSelect from "Pages/Admin/Users/Table/MultipleSelect"
import AdminUsersTableToolbar from "Pages/Admin/Users/Table/Toolbar"


export default function UserListTable() {
	const { getTableData, isTableLoading } = useAdminListTable()
	const { onChangeEnabled } = useManageEnabledUsers()

	useEffect(() => {
		getTableData()
	}, [])

	if (isTableLoading) return <AppResultsSkeleton/>

	return <AppCrudTable
		title={<AppCardTitle icon="users" title="Users List"/>}
		data={tableData.value}
		options={{
			selectableRows: 'multiple',
			customToolbar: () => <AdminUsersTableToolbar/>,
			customToolbarSelect: (selectedData, setSelectedRows) => <MultipleUserSelect
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}/>
		}}
		columns={[
			nameColumn(),
			emailColumn(),
			companyColumn(),
			// roleColumn(),
			...createdColumn(),
			...disabledColumn(),
			...enabledColumn(onChangeEnabled),
			actionsColumn()
		]}
	/>
}